import { render } from "./ProductsComponent.vue?vue&type=template&id=024eea5d&scoped=true"
import script from "./ProductsComponent.vue?vue&type=script&lang=js"
export * from "./ProductsComponent.vue?vue&type=script&lang=js"

import "./ProductsComponent.vue?vue&type=style&index=0&id=024eea5d&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bdroyelfrontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-024eea5d"]])

export default __exports__